import common from './common.json';
import createPost from './create-post.json';
import details from './details.json';
import editPost from './edit-post.json';
import postSteps from './post-steps.json';
import posts from './posts.json';

export default {
  common,
  createPost,
  details,
  editPost,
  postSteps,
  posts,
};
